import { forwardRef } from "react";

import * as S from "./button-label.styles";
import { ButtonLabelProps } from "./button-label.types";

export const ButtonLabel = forwardRef<
  Partial<HTMLButtonElement>,
  ButtonLabelProps
>(({ variant, children, css, ...props }, ref) => {
  return (
    <S.Wrapper
      css={css}
      variant={variant}
      // @ts-ignore
      onClick={props.onClick}
    >
      {/* @ts-ignore */}
      <S.Button {...props} ref={ref}>
        {children}
      </S.Button>
    </S.Wrapper>
  );
});
